const buildCanonicalUrl = (fullUrl = '') => {
  const [canonicalUrl] = fullUrl.split('?');
  return canonicalUrl;
};

export default buildCanonicalUrl;
